import React, { useEffect, useRef } from 'react'
import style from './chat-container.module.sass'
import c from 'classnames'
import { LlmChatMessageSenderType } from '@/__gen/types'
import { CloseOutlined, RobotOutlined, SendOutlined, UserOutlined } from '@ant-design/icons'

import { Avatar } from 'antd'
import { useLlm } from './useLlm'


export const ChatContainer = ({messages}: {messages: ReturnType<typeof useLlm>['messages']}) => {
	const formatTime = (date: Date) => {
		return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
	}
	const messagesEndRef = useRef<HTMLDivElement>(null)

	const scrollToBottom = () => {
		messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
	}
	useEffect(() => {
		scrollToBottom()
	}, [messages])
	return (
		<div className={style.chatContainer}>
			<div className={style.messagesContainer}>
				{messages && messages.map((message) => (
					<div
						key={message.id}
						className={c(style.messageRow, {
							[style.userMessage]: message.sender == LlmChatMessageSenderType.User,
							[style.aiMessage]: message.sender == LlmChatMessageSenderType.Agent,
						})}
					>
						<Avatar
							className={style.avatar}
							icon={message.sender == LlmChatMessageSenderType.User ? <UserOutlined /> : <RobotOutlined />}
							style={{
								backgroundColor: message.sender == LlmChatMessageSenderType.User ? '#1890ff' : '#52c41a',
							}}
							size="small"
						/>
						<div className={style.messageContent}>
							<div className={style.messageText}>
								{message.content}
								{message.sender == LlmChatMessageSenderType.Agent && message.responseReceivedAt === null && <div className={style.typingIndicator}>
								<span></span>
								<span></span>
								<span></span>
							</div>}
							</div>
							<div className={style.messageTime}>{formatTime(new Date(message.created))}</div>
						</div>
					</div>
				))}
				<div ref={messagesEndRef} />
			</div>
		</div>
	)
}